import {
  FunctionComponent,
  PropsWithChildren,
  ReactElement,
  useEffect,
} from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { FormControl } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { useAppDispatch } from '../../../../../../../../store/hooks';
import { filterReviewsByDate } from '../../../../store/slices/slices/reviews.slice';
import { AllReviewsFiltersProps } from '../../types/all-reviews-filters-props';
import withFilterValues from '../with-filter-values';
import { DateInputField } from './components/date-input-field';

const DateDropdown: FunctionComponent<AllReviewsFiltersProps> = (
  props: PropsWithChildren<AllReviewsFiltersProps>
): ReactElement => {
  const dispatch = useAppDispatch();

  const { setFieldValue, filterValues, values } = props;

  useEffect(() => {
    if (filterValues.date) {
      setFieldValue('date', filterValues.date);
    }
  }, [filterValues.date]);

  return (
    <FormControl
      data-testid="dates-dropdown"
      key="dates-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          className="datepicker"
          label="Date"
          value={filterValues.date ? values.date : null}
          components={{ OpenPickerIcon: ArrowDropDownIcon }}
          inputFormat="yyyy-MM-dd"
          renderInput={textFieldProps => (
            <DateInputField
              dateValue={values.date}
              setFieldValue={setFieldValue}
              textFieldProps={textFieldProps}
            />
          )}
          onChange={value => {
            setFieldValue('date', value);
            dispatch(
              filterReviewsByDate(value ? value.toISOString() : undefined)
            );
          }}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default withFilterValues(DateDropdown);
